/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import Vue, { PropOptions } from 'vue';
import { createCommonRender, createCommonMethod } from './vue-component-lib/utils';

import type { Components, JSX } from '@tarojs/components/dist/types/components';

// @ts-ignore
import { defineCustomElementTaroAdCore as defineTaroAdCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAdCustomCore as defineTaroAdCustomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAnimationVideoCore as defineTaroAnimationVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAnimationViewCore as defineTaroAnimationViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroArCameraCore as defineTaroArCameraCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAudioCore as defineTaroAudioCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroAwemeDataCore as defineTaroAwemeDataCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroBlockCore as defineTaroBlockCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroButtonCore as defineTaroButtonCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCameraCore as defineTaroCameraCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCanvasCore as defineTaroCanvasCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroChannelLiveCore as defineTaroChannelLiveCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroChannelVideoCore as defineTaroChannelVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCheckboxCore as defineTaroCheckboxCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCheckboxGroupCore as defineTaroCheckboxGroupCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCommentDetailCore as defineTaroCommentDetailCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCommentListCore as defineTaroCommentListCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroContactButtonCore as defineTaroContactButtonCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCoverImageCore as defineTaroCoverImageCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCoverViewCore as defineTaroCoverViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroCustomWrapperCore as defineTaroCustomWrapperCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroEditorCore as defineTaroEditorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFollowSwanCore as defineTaroFollowSwanCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFormCore as defineTaroFormCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroFunctionalPageNavigatorCore as defineTaroFunctionalPageNavigatorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroGridViewCore as defineTaroGridViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroIconCore as defineTaroIconCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroImageCore as defineTaroImageCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroInlinePaymentPanelCore as defineTaroInlinePaymentPanelCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroInputCore as defineTaroInputCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroKeyboardAccessoryCore as defineTaroKeyboardAccessoryCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLabelCore as defineTaroLabelCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLifestyleCore as defineTaroLifestyleCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLikeCore as defineTaroLikeCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroListViewCore as defineTaroListViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLivePlayerCore as defineTaroLivePlayerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLivePusherCore as defineTaroLivePusherCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLoginCore as defineTaroLoginCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroLottieCore as defineTaroLottieCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMapCore as defineTaroMapCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMatchMediaCore as defineTaroMatchMediaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMovableAreaCore as defineTaroMovableAreaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroMovableViewCore as defineTaroMovableViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNativeSlotCore as defineTaroNativeSlotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNavigationBarCore as defineTaroNavigationBarCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroNavigatorCore as defineTaroNavigatorCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOfficialAccountCore as defineTaroOfficialAccountCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroOpenDataCore as defineTaroOpenDataCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPageContainerCore as defineTaroPageContainerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPageMetaCore as defineTaroPageMetaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerCore as defineTaroPickerCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerGroup as defineTaroPickerGroup } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerViewColumnCore as defineTaroPickerViewColumnCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPickerViewCore as defineTaroPickerViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroProgressCore as defineTaroProgressCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroPullToRefresh as defineTaroPullToRefresh } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRadioCore as defineTaroRadioCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRadioGroupCore as defineTaroRadioGroupCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRichTextCore as defineTaroRichTextCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRootPortalCore as defineTaroRootPortalCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRtcRoomCore as defineTaroRtcRoomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroRtcRoomItemCore as defineTaroRtcRoomItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroScrollViewCore as defineTaroScrollViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroShareElementCore as defineTaroShareElementCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSliderCore as defineTaroSliderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSlotCore as defineTaroSlotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSnapshotCore as defineTaroSnapshotCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroStickyHeaderCore as defineTaroStickyHeaderCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroStickySectionCore as defineTaroStickySectionCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwiperCore as defineTaroSwiperCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwiperItemCore as defineTaroSwiperItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroSwitchCore as defineTaroSwitchCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabItemCore as defineTaroTabItemCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabbar as defineTaroTabbar } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTabsCore as defineTaroTabsCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTextCore as defineTaroTextCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroTextareaCore as defineTaroTextareaCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoControl as defineTaroVideoControl } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoCore as defineTaroVideoCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVideoDanmu as defineTaroVideoDanmu } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroViewCore as defineTaroViewCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroVoipRoomCore as defineTaroVoipRoomCore } from '@tarojs/components/dist/components';
// @ts-ignore
import { defineCustomElementTaroWebViewCore as defineTaroWebViewCore } from '@tarojs/components/dist/components';


export const Ad = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-ad-core', [], defineTaroAdCore),
});


export const AdCustom = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-ad-custom-core', [], defineTaroAdCustomCore),
});


export const AnimationVideo = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-animation-video-core', [], defineTaroAnimationVideoCore),
});


export const AnimationView = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-animation-view-core', [], defineTaroAnimationViewCore),
});


export const ArCamera = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-ar-camera-core', [], defineTaroArCameraCore),
});


export const Audio = /*@__PURE__*/ Vue.extend({
  props: {
    src: {} as PropOptions<JSX.TaroAudioCore['src']>,
    controls: {} as PropOptions<JSX.TaroAudioCore['controls']>,
    autoplay: {} as PropOptions<JSX.TaroAudioCore['autoplay']>,
    loop: {} as PropOptions<JSX.TaroAudioCore['loop']>,
    muted: {} as PropOptions<JSX.TaroAudioCore['muted']>,
    nativeProps: {} as PropOptions<JSX.TaroAudioCore['nativeProps']>
  },
  render: createCommonRender('taro-audio-core', ['error', 'play', 'pause', 'timeupdate', 'ended'], defineTaroAudioCore),
});


export const AwemeData = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-aweme-data-core', [], defineTaroAwemeDataCore),
});


export const Block = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('fragment', [], defineTaroBlockCore),
});


export const Button = /*@__PURE__*/ Vue.extend({
  props: {
    disabled: {} as PropOptions<JSX.TaroButtonCore['disabled']>,
    hoverClass: {} as PropOptions<JSX.TaroButtonCore['hoverClass']>,
    type: {} as PropOptions<JSX.TaroButtonCore['type']>,
    hoverStartTime: {} as PropOptions<JSX.TaroButtonCore['hoverStartTime']>,
    hoverStayTime: {} as PropOptions<JSX.TaroButtonCore['hoverStayTime']>,
    size: {} as PropOptions<JSX.TaroButtonCore['size']>,
    plain: {} as PropOptions<JSX.TaroButtonCore['plain']>,
    loading: {} as PropOptions<JSX.TaroButtonCore['loading']>,
    formType: {} as PropOptions<JSX.TaroButtonCore['formType']>
  },
  render: createCommonRender('taro-button-core', ['tarobuttonsubmit', 'tarobuttonreset'], defineTaroButtonCore),
});


export const Camera = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-camera-core', [], defineTaroCameraCore),
});


export const Canvas = /*@__PURE__*/ Vue.extend({
  props: {
    canvasId: {} as PropOptions<JSX.TaroCanvasCore['canvasId']>,
    height: {} as PropOptions<JSX.TaroCanvasCore['height']>,
    width: {} as PropOptions<JSX.TaroCanvasCore['width']>,
    nativeProps: {} as PropOptions<JSX.TaroCanvasCore['nativeProps']>
  },
  render: createCommonRender('taro-canvas-core', ['longtap'], defineTaroCanvasCore),
});


export const ChannelLive = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-channel-live-core', [], defineTaroChannelLiveCore),
});


export const ChannelVideo = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-channel-video-core', [], defineTaroChannelVideoCore),
});


export const Checkbox = /*@__PURE__*/ Vue.extend({
  props: {
    name: {} as PropOptions<JSX.TaroCheckboxCore['name']>,
    value: {} as PropOptions<JSX.TaroCheckboxCore['value']>,
    color: {} as PropOptions<JSX.TaroCheckboxCore['color']>,
    id: {} as PropOptions<JSX.TaroCheckboxCore['id']>,
    checked: {} as PropOptions<JSX.TaroCheckboxCore['checked']>,
    disabled: {} as PropOptions<JSX.TaroCheckboxCore['disabled']>,
    nativeProps: {} as PropOptions<JSX.TaroCheckboxCore['nativeProps']>
  },
  render: createCommonRender('taro-checkbox-core', ['checkboxchange'], defineTaroCheckboxCore),
});


export const CheckboxGroup = /*@__PURE__*/ Vue.extend({
  props: {
    name: {} as PropOptions<JSX.TaroCheckboxGroupCore['name']>
  },
  render: createCommonRender('taro-checkbox-group-core', ['change'], defineTaroCheckboxGroupCore),
});


export const CommentDetail = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-comment-detail-core', [], defineTaroCommentDetailCore),
});


export const CommentList = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-comment-list-core', [], defineTaroCommentListCore),
});


export const ContactButton = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-contact-button-core', [], defineTaroContactButtonCore),
});


export const CoverImage = /*@__PURE__*/ Vue.extend({
  props: {
    src: {} as PropOptions<JSX.TaroCoverImageCore['src']>,
    nativeProps: {} as PropOptions<JSX.TaroCoverImageCore['nativeProps']>
  },
  render: createCommonRender('taro-cover-image-core', ['load', 'error'], defineTaroCoverImageCore),
});


export const CoverView = /*@__PURE__*/ Vue.extend({
  props: {
    animation: {} as PropOptions<JSX.TaroCoverViewCore['animation']>,
    hoverClass: {} as PropOptions<JSX.TaroCoverViewCore['hoverClass']>,
    hoverStartTime: {} as PropOptions<JSX.TaroCoverViewCore['hoverStartTime']>,
    hoverStayTime: {} as PropOptions<JSX.TaroCoverViewCore['hoverStayTime']>
  },
  render: createCommonRender('taro-cover-view-core', ['longpress'], defineTaroCoverViewCore),
});


export const CustomWrapper = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-custom-wrapper-core', [], defineTaroCustomWrapperCore),
});


export const Editor = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-editor-core', [], defineTaroEditorCore),
});


export const FollowSwan = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-follow-swan-core', [], defineTaroFollowSwanCore),
});


export const Form = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-form-core', ['submit'], defineTaroFormCore),
});


export const FunctionalPageNavigator = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-functional-page-navigator-core', [], defineTaroFunctionalPageNavigatorCore),
});


export const GridView = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-grid-view-core', [], defineTaroGridViewCore),
});


export const Icon = /*@__PURE__*/ Vue.extend({
  props: {
    type: {} as PropOptions<JSX.TaroIconCore['type']>,
    size: {} as PropOptions<JSX.TaroIconCore['size']>,
    color: {} as PropOptions<JSX.TaroIconCore['color']>
  },
  render: createCommonRender('taro-icon-core', [], defineTaroIconCore),
});


export const Image = /*@__PURE__*/ Vue.extend({
  props: {
    src: {} as PropOptions<JSX.TaroImageCore['src']>,
    mode: {} as PropOptions<JSX.TaroImageCore['mode']>,
    lazyLoad: {} as PropOptions<JSX.TaroImageCore['lazyLoad']>,
    nativeProps: {} as PropOptions<JSX.TaroImageCore['nativeProps']>
  },
  render: createCommonRender('taro-image-core', ['load', 'error'], defineTaroImageCore),
});


export const InlinePaymentPanel = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-inline-payment-panel-core', [], defineTaroInlinePaymentPanelCore),
});


export const Input = /*@__PURE__*/ Vue.extend({
  props: {
    value: {} as PropOptions<JSX.TaroInputCore['value']>,
    type: {} as PropOptions<JSX.TaroInputCore['type']>,
    password: {} as PropOptions<JSX.TaroInputCore['password']>,
    placeholder: {} as PropOptions<JSX.TaroInputCore['placeholder']>,
    disabled: {} as PropOptions<JSX.TaroInputCore['disabled']>,
    maxlength: {} as PropOptions<JSX.TaroInputCore['maxlength']>,
    autoFocus: {} as PropOptions<JSX.TaroInputCore['autoFocus']>,
    confirmType: {} as PropOptions<JSX.TaroInputCore['confirmType']>,
    name: {} as PropOptions<JSX.TaroInputCore['name']>,
    nativeProps: {} as PropOptions<JSX.TaroInputCore['nativeProps']>
  },
  model: { prop: 'value' , event: 'update:modelValue' },
  methods: {
    focus: createCommonMethod('focus') as Components.TaroInputCore['focus']
  },
  render: createCommonRender('taro-input-core', ['input', 'paste', 'focus', 'blur', 'confirm', 'change', 'keydown'], defineTaroInputCore),
});


export const KeyboardAccessory = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-keyboard-accessory-core', [], defineTaroKeyboardAccessoryCore),
});


export const Label = /*@__PURE__*/ Vue.extend({
  props: {
    for: {} as PropOptions<JSX.TaroLabelCore['for']>
  },
  render: createCommonRender('taro-label-core', [], defineTaroLabelCore),
});


export const Lifestyle = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-lifestyle-core', [], defineTaroLifestyleCore),
});


export const Like = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-like-core', [], defineTaroLikeCore),
});


export const ListView = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-list-view-core', [], defineTaroListViewCore),
});


export const LivePlayer = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-live-player-core', [], defineTaroLivePlayerCore),
});


export const LivePusher = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-live-pusher-core', [], defineTaroLivePusherCore),
});


export const Login = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-login-core', [], defineTaroLoginCore),
});


export const Lottie = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-lottie-core', [], defineTaroLottieCore),
});


export const Map = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-map-core', [], defineTaroMapCore),
});


export const MatchMedia = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-match-media-core', [], defineTaroMatchMediaCore),
});


export const MovableArea = /*@__PURE__*/ Vue.extend({
  props: {
    scaleArea: {} as PropOptions<JSX.TaroMovableAreaCore['scaleArea']>
  },
  render: createCommonRender('taro-movable-area-core', [], defineTaroMovableAreaCore),
});


export const MovableView = /*@__PURE__*/ Vue.extend({
  props: {
    x: {} as PropOptions<JSX.TaroMovableViewCore['x']>,
    y: {} as PropOptions<JSX.TaroMovableViewCore['y']>,
    direction: {} as PropOptions<JSX.TaroMovableViewCore['direction']>,
    outOfBounds: {} as PropOptions<JSX.TaroMovableViewCore['outOfBounds']>,
    inertia: {} as PropOptions<JSX.TaroMovableViewCore['inertia']>,
    friction: {} as PropOptions<JSX.TaroMovableViewCore['friction']>,
    damping: {} as PropOptions<JSX.TaroMovableViewCore['damping']>,
    disabled: {} as PropOptions<JSX.TaroMovableViewCore['disabled']>,
    scale: {} as PropOptions<JSX.TaroMovableViewCore['scale']>,
    scaleMin: {} as PropOptions<JSX.TaroMovableViewCore['scaleMin']>,
    scaleMax: {} as PropOptions<JSX.TaroMovableViewCore['scaleMax']>,
    scaleValue: {} as PropOptions<JSX.TaroMovableViewCore['scaleValue']>,
    animation: {} as PropOptions<JSX.TaroMovableViewCore['animation']>
  },
  methods: {
    setParent: createCommonMethod('setParent') as Components.TaroMovableViewCore['setParent'],
    endScale: createCommonMethod('endScale') as Components.TaroMovableViewCore['endScale'],
    setScale: createCommonMethod('setScale') as Components.TaroMovableViewCore['setScale']
  },
  render: createCommonRender('taro-movable-view-core', ['change', 'scale', 'htouchmove', 'vtouchmove'], defineTaroMovableViewCore),
});


export const NativeSlot = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-native-slot-core', [], defineTaroNativeSlotCore),
});


export const NavigationBar = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-navigation-bar-core', [], defineTaroNavigationBarCore),
});


export const Navigator = /*@__PURE__*/ Vue.extend({
  props: {
    hoverClass: {} as PropOptions<JSX.TaroNavigatorCore['hoverClass']>,
    url: {} as PropOptions<JSX.TaroNavigatorCore['url']>,
    openType: {} as PropOptions<JSX.TaroNavigatorCore['openType']>,
    isHover: {} as PropOptions<JSX.TaroNavigatorCore['isHover']>,
    delta: {} as PropOptions<JSX.TaroNavigatorCore['delta']>
  },
  render: createCommonRender('taro-navigator-core', ['cuccess', 'fail', 'complete'], defineTaroNavigatorCore),
});


export const OfficialAccount = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-official-account-core', [], defineTaroOfficialAccountCore),
});


export const OpenData = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-open-data-core', [], defineTaroOpenDataCore),
});


export const PageContainer = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-page-container-core', [], defineTaroPageContainerCore),
});


export const PageMeta = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-page-meta-core', [], defineTaroPageMetaCore),
});


export const Picker = /*@__PURE__*/ Vue.extend({
  props: {
    mode: {} as PropOptions<JSX.TaroPickerCore['mode']>,
    disabled: {} as PropOptions<JSX.TaroPickerCore['disabled']>,
    range: {} as PropOptions<JSX.TaroPickerCore['range']>,
    rangeKey: {} as PropOptions<JSX.TaroPickerCore['rangeKey']>,
    value: {} as PropOptions<JSX.TaroPickerCore['value']>,
    start: {} as PropOptions<JSX.TaroPickerCore['start']>,
    end: {} as PropOptions<JSX.TaroPickerCore['end']>,
    fields: {} as PropOptions<JSX.TaroPickerCore['fields']>,
    name: {} as PropOptions<JSX.TaroPickerCore['name']>,
    textProps: {} as PropOptions<JSX.TaroPickerCore['textProps']>
  },
  model: { prop: 'value' , event: 'update:modelValue' },
  render: createCommonRender('taro-picker-core', ['change', 'columnchange', 'cancel'], defineTaroPickerCore),
});


export const PickerGroup = /*@__PURE__*/ Vue.extend({
  props: {
    mode: {} as PropOptions<JSX.TaroPickerGroup['mode']>,
    range: {} as PropOptions<JSX.TaroPickerGroup['range']>,
    rangeKey: {} as PropOptions<JSX.TaroPickerGroup['rangeKey']>,
    height: {} as PropOptions<JSX.TaroPickerGroup['height']>,
    columnId: {} as PropOptions<JSX.TaroPickerGroup['columnId']>,
    updateHeight: {} as PropOptions<JSX.TaroPickerGroup['updateHeight']>,
    updateDay: {} as PropOptions<JSX.TaroPickerGroup['updateDay']>
  },
  methods: {
    handleMoveStart: createCommonMethod('handleMoveStart') as Components.TaroPickerGroup['handleMoveStart'],
    handleMoving: createCommonMethod('handleMoving') as Components.TaroPickerGroup['handleMoving'],
    handleMoveEnd: createCommonMethod('handleMoveEnd') as Components.TaroPickerGroup['handleMoveEnd']
  },
  render: createCommonRender('taro-picker-group', ['columnChange'], defineTaroPickerGroup),
});


export const PickerViewColumn = /*@__PURE__*/ Vue.extend({
  props: {
    col: {} as PropOptions<JSX.TaroPickerViewColumnCore['col']>,
    initialPosition: {} as PropOptions<JSX.TaroPickerViewColumnCore['initialPosition']>,
    paddingVertical: {} as PropOptions<JSX.TaroPickerViewColumnCore['paddingVertical']>
  },
  render: createCommonRender('taro-picker-view-column-core', ['onselect', 'onselectstart', 'onselectend'], defineTaroPickerViewColumnCore),
});


export const PickerView = /*@__PURE__*/ Vue.extend({
  props: {
    indicatorStyle: {} as PropOptions<JSX.TaroPickerViewCore['indicatorStyle']>,
    indicatorClass: {} as PropOptions<JSX.TaroPickerViewCore['indicatorClass']>,
    value: {} as PropOptions<JSX.TaroPickerViewCore['value']>,
    maskStyle: {} as PropOptions<JSX.TaroPickerViewCore['maskStyle']>,
    maskClass: {} as PropOptions<JSX.TaroPickerViewCore['maskClass']>
  },
  render: createCommonRender('taro-picker-view-core', ['change', 'pickstart', 'pickend'], defineTaroPickerViewCore),
});


export const Progress = /*@__PURE__*/ Vue.extend({
  props: {
    percent: {} as PropOptions<JSX.TaroProgressCore['percent']>,
    showInfo: {} as PropOptions<JSX.TaroProgressCore['showInfo']>,
    borderRadius: {} as PropOptions<JSX.TaroProgressCore['borderRadius']>,
    fontSize: {} as PropOptions<JSX.TaroProgressCore['fontSize']>,
    strokeWidth: {} as PropOptions<JSX.TaroProgressCore['strokeWidth']>,
    activeColor: {} as PropOptions<JSX.TaroProgressCore['activeColor']>,
    backgroundColor: {} as PropOptions<JSX.TaroProgressCore['backgroundColor']>,
    active: {} as PropOptions<JSX.TaroProgressCore['active']>
  },
  render: createCommonRender('taro-progress-core', [], defineTaroProgressCore),
});


export const PullToRefresh = /*@__PURE__*/ Vue.extend({
  props: {
    prefixCls: {} as PropOptions<JSX.TaroPullToRefresh['prefixCls']>,
    distanceToRefresh: {} as PropOptions<JSX.TaroPullToRefresh['distanceToRefresh']>,
    damping: {} as PropOptions<JSX.TaroPullToRefresh['damping']>,
    indicator: {} as PropOptions<JSX.TaroPullToRefresh['indicator']>
  },
  render: createCommonRender('taro-pull-to-refresh', ['refresh'], defineTaroPullToRefresh),
});


export const Radio = /*@__PURE__*/ Vue.extend({
  props: {
    name: {} as PropOptions<JSX.TaroRadioCore['name']>,
    value: {} as PropOptions<JSX.TaroRadioCore['value']>,
    id: {} as PropOptions<JSX.TaroRadioCore['id']>,
    checked: {} as PropOptions<JSX.TaroRadioCore['checked']>,
    disabled: {} as PropOptions<JSX.TaroRadioCore['disabled']>,
    nativeProps: {} as PropOptions<JSX.TaroRadioCore['nativeProps']>
  },
  render: createCommonRender('taro-radio-core', ['radiochange'], defineTaroRadioCore),
});


export const RadioGroup = /*@__PURE__*/ Vue.extend({
  props: {
    name: {} as PropOptions<JSX.TaroRadioGroupCore['name']>
  },
  render: createCommonRender('taro-radio-group-core', ['change'], defineTaroRadioGroupCore),
});


export const RichText = /*@__PURE__*/ Vue.extend({
  props: {
    nodes: {} as PropOptions<JSX.TaroRichTextCore['nodes']>,
    selectable: {} as PropOptions<JSX.TaroRichTextCore['selectable']>,
    userSelect: {} as PropOptions<JSX.TaroRichTextCore['userSelect']>,
    space: {} as PropOptions<JSX.TaroRichTextCore['space']>
  },
  render: createCommonRender('taro-rich-text-core', [], defineTaroRichTextCore),
});


export const RootPortal = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-root-portal-core', [], defineTaroRootPortalCore),
});


export const RtcRoom = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-rtc-room-core', [], defineTaroRtcRoomCore),
});


export const RtcRoomItem = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-rtc-room-item-core', [], defineTaroRtcRoomItemCore),
});


export const ScrollView = /*@__PURE__*/ Vue.extend({
  props: {
    scrollX: {} as PropOptions<JSX.TaroScrollViewCore['scrollX']>,
    scrollY: {} as PropOptions<JSX.TaroScrollViewCore['scrollY']>,
    upperThreshold: {} as PropOptions<JSX.TaroScrollViewCore['upperThreshold']>,
    lowerThreshold: {} as PropOptions<JSX.TaroScrollViewCore['lowerThreshold']>,
    mpScrollTop: {} as PropOptions<JSX.TaroScrollViewCore['mpScrollTop']>,
    mpScrollLeft: {} as PropOptions<JSX.TaroScrollViewCore['mpScrollLeft']>,
    mpScrollIntoView: {} as PropOptions<JSX.TaroScrollViewCore['mpScrollIntoView']>,
    mpScrollIntoViewAlignment: {} as PropOptions<JSX.TaroScrollViewCore['mpScrollIntoViewAlignment']>,
    animated: {} as PropOptions<JSX.TaroScrollViewCore['animated']>
  },
  methods: {
    mpScrollToMethod: createCommonMethod('mpScrollToMethod') as Components.TaroScrollViewCore['mpScrollToMethod'],
    mpScrollIntoViewMethod: createCommonMethod('mpScrollIntoViewMethod') as Components.TaroScrollViewCore['mpScrollIntoViewMethod']
  },
  render: createCommonRender('taro-scroll-view-core', ['scroll', 'scrolltoupper', 'scrolltolower'], defineTaroScrollViewCore),
});


export const ShareElement = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-share-element-core', [], defineTaroShareElementCore),
});


export const Slider = /*@__PURE__*/ Vue.extend({
  props: {
    min: {} as PropOptions<JSX.TaroSliderCore['min']>,
    max: {} as PropOptions<JSX.TaroSliderCore['max']>,
    step: {} as PropOptions<JSX.TaroSliderCore['step']>,
    disabled: {} as PropOptions<JSX.TaroSliderCore['disabled']>,
    value: {} as PropOptions<JSX.TaroSliderCore['value']>,
    activeColor: {} as PropOptions<JSX.TaroSliderCore['activeColor']>,
    backgroundColor: {} as PropOptions<JSX.TaroSliderCore['backgroundColor']>,
    blockSize: {} as PropOptions<JSX.TaroSliderCore['blockSize']>,
    blockColor: {} as PropOptions<JSX.TaroSliderCore['blockColor']>,
    showValue: {} as PropOptions<JSX.TaroSliderCore['showValue']>,
    name: {} as PropOptions<JSX.TaroSliderCore['name']>
  },
  model: { prop: 'value' , event: 'update:modelValue' },
  render: createCommonRender('taro-slider-core', ['change', 'changing'], defineTaroSliderCore),
});


export const Slot = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-slot-core', [], defineTaroSlotCore),
});


export const Snapshot = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-snapshot-core', [], defineTaroSnapshotCore),
});


export const StickyHeader = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-sticky-header-core', [], defineTaroStickyHeaderCore),
});


export const StickySection = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-sticky-section-core', [], defineTaroStickySectionCore),
});


export const Swiper = /*@__PURE__*/ Vue.extend({
  props: {
    indicatorDots: {} as PropOptions<JSX.TaroSwiperCore['indicatorDots']>,
    indicatorColor: {} as PropOptions<JSX.TaroSwiperCore['indicatorColor']>,
    indicatorActiveColor: {} as PropOptions<JSX.TaroSwiperCore['indicatorActiveColor']>,
    autoplay: {} as PropOptions<JSX.TaroSwiperCore['autoplay']>,
    current: {} as PropOptions<JSX.TaroSwiperCore['current']>,
    interval: {} as PropOptions<JSX.TaroSwiperCore['interval']>,
    duration: {} as PropOptions<JSX.TaroSwiperCore['duration']>,
    circular: {} as PropOptions<JSX.TaroSwiperCore['circular']>,
    vertical: {} as PropOptions<JSX.TaroSwiperCore['vertical']>,
    previousMargin: {} as PropOptions<JSX.TaroSwiperCore['previousMargin']>,
    nextMargin: {} as PropOptions<JSX.TaroSwiperCore['nextMargin']>,
    displayMultipleItems: {} as PropOptions<JSX.TaroSwiperCore['displayMultipleItems']>,
    full: {} as PropOptions<JSX.TaroSwiperCore['full']>,
    zoom: {} as PropOptions<JSX.TaroSwiperCore['zoom']>
  },
  render: createCommonRender('taro-swiper-core', ['change', 'animationfinish'], defineTaroSwiperCore),
});


export const SwiperItem = /*@__PURE__*/ Vue.extend({
  props: {
    itemId: {} as PropOptions<JSX.TaroSwiperItemCore['itemId']>
  },
  render: createCommonRender('taro-swiper-item-core', [], defineTaroSwiperItemCore),
});


export const Switch = /*@__PURE__*/ Vue.extend({
  props: {
    type: {} as PropOptions<JSX.TaroSwitchCore['type']>,
    checked: {} as PropOptions<JSX.TaroSwitchCore['checked']>,
    color: {} as PropOptions<JSX.TaroSwitchCore['color']>,
    name: {} as PropOptions<JSX.TaroSwitchCore['name']>,
    disabled: {} as PropOptions<JSX.TaroSwitchCore['disabled']>,
    nativeProps: {} as PropOptions<JSX.TaroSwitchCore['nativeProps']>
  },
  model: { prop: 'checked' , event: 'update:modelValue' },
  render: createCommonRender('taro-switch-core', ['change'], defineTaroSwitchCore),
});


export const TabItem = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-tab-item-core', [], defineTaroTabItemCore),
});


export const Tabbar = /*@__PURE__*/ Vue.extend({
  props: {
    conf: {} as PropOptions<JSX.TaroTabbar['conf']>
  },
  render: createCommonRender('taro-tabbar', ['longpress'], defineTaroTabbar),
});


export const Tabs = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-tabs-core', [], defineTaroTabsCore),
});


export const Text = /*@__PURE__*/ Vue.extend({
  props: {
    selectable: {} as PropOptions<JSX.TaroTextCore['selectable']>,
    userSelect: {} as PropOptions<JSX.TaroTextCore['userSelect']>,
    space: {} as PropOptions<JSX.TaroTextCore['space']>,
    numberOfLines: {} as PropOptions<JSX.TaroTextCore['numberOfLines']>
  },
  render: createCommonRender('taro-text-core', [], defineTaroTextCore),
});


export const Textarea = /*@__PURE__*/ Vue.extend({
  props: {
    value: {} as PropOptions<JSX.TaroTextareaCore['value']>,
    placeholder: {} as PropOptions<JSX.TaroTextareaCore['placeholder']>,
    disabled: {} as PropOptions<JSX.TaroTextareaCore['disabled']>,
    maxlength: {} as PropOptions<JSX.TaroTextareaCore['maxlength']>,
    autoFocus: {} as PropOptions<JSX.TaroTextareaCore['autoFocus']>,
    autoHeight: {} as PropOptions<JSX.TaroTextareaCore['autoHeight']>,
    name: {} as PropOptions<JSX.TaroTextareaCore['name']>,
    nativeProps: {} as PropOptions<JSX.TaroTextareaCore['nativeProps']>
  },
  model: { prop: 'value' , event: 'update:modelValue' },
  methods: {
    focus: createCommonMethod('focus') as Components.TaroTextareaCore['focus']
  },
  render: createCommonRender('taro-textarea-core', ['input', 'focus', 'blur', 'confirm', 'change', 'linechange', 'keydown'], defineTaroTextareaCore),
});


export const VideoControl = /*@__PURE__*/ Vue.extend({
  props: {
    controls: {} as PropOptions<JSX.TaroVideoControl['controls']>,
    currentTime: {} as PropOptions<JSX.TaroVideoControl['currentTime']>,
    duration: {} as PropOptions<JSX.TaroVideoControl['duration']>,
    isPlaying: {} as PropOptions<JSX.TaroVideoControl['isPlaying']>,
    pauseFunc: {} as PropOptions<JSX.TaroVideoControl['pauseFunc']>,
    playFunc: {} as PropOptions<JSX.TaroVideoControl['playFunc']>,
    seekFunc: {} as PropOptions<JSX.TaroVideoControl['seekFunc']>,
    showPlayBtn: {} as PropOptions<JSX.TaroVideoControl['showPlayBtn']>,
    showProgress: {} as PropOptions<JSX.TaroVideoControl['showProgress']>
  },
  methods: {
    setProgressBall: createCommonMethod('setProgressBall') as Components.TaroVideoControl['setProgressBall'],
    toggleVisibility: createCommonMethod('toggleVisibility') as Components.TaroVideoControl['toggleVisibility'],
    getIsDraggingProgressBall: createCommonMethod('getIsDraggingProgressBall') as Components.TaroVideoControl['getIsDraggingProgressBall'],
    setCurrentTime: createCommonMethod('setCurrentTime') as Components.TaroVideoControl['setCurrentTime']
  },
  render: createCommonRender('taro-video-control', [], defineTaroVideoControl),
});


export const Video = /*@__PURE__*/ Vue.extend({
  props: {
    src: {} as PropOptions<JSX.TaroVideoCore['src']>,
    duration: {} as PropOptions<JSX.TaroVideoCore['duration']>,
    controls: {} as PropOptions<JSX.TaroVideoCore['controls']>,
    autoplay: {} as PropOptions<JSX.TaroVideoCore['autoplay']>,
    loop: {} as PropOptions<JSX.TaroVideoCore['loop']>,
    muted: {} as PropOptions<JSX.TaroVideoCore['muted']>,
    initialTime: {} as PropOptions<JSX.TaroVideoCore['initialTime']>,
    poster: {} as PropOptions<JSX.TaroVideoCore['poster']>,
    objectFit: {} as PropOptions<JSX.TaroVideoCore['objectFit']>,
    showProgress: {} as PropOptions<JSX.TaroVideoCore['showProgress']>,
    showFullscreenBtn: {} as PropOptions<JSX.TaroVideoCore['showFullscreenBtn']>,
    showPlayBtn: {} as PropOptions<JSX.TaroVideoCore['showPlayBtn']>,
    showCenterPlayBtn: {} as PropOptions<JSX.TaroVideoCore['showCenterPlayBtn']>,
    showMuteBtn: {} as PropOptions<JSX.TaroVideoCore['showMuteBtn']>,
    danmuList: {} as PropOptions<JSX.TaroVideoCore['danmuList']>,
    danmuBtn: {} as PropOptions<JSX.TaroVideoCore['danmuBtn']>,
    enableDanmu: {} as PropOptions<JSX.TaroVideoCore['enableDanmu']>,
    enablePlayGesture: {} as PropOptions<JSX.TaroVideoCore['enablePlayGesture']>,
    enableProgressGesture: {} as PropOptions<JSX.TaroVideoCore['enableProgressGesture']>,
    vslideGesture: {} as PropOptions<JSX.TaroVideoCore['vslideGesture']>,
    vslideGestureInFullscreen: {} as PropOptions<JSX.TaroVideoCore['vslideGestureInFullscreen']>,
    nativeProps: {} as PropOptions<JSX.TaroVideoCore['nativeProps']>
  },
  methods: {
    getHlsObject: createCommonMethod('getHlsObject') as Components.TaroVideoCore['getHlsObject'],
    play: createCommonMethod('play') as Components.TaroVideoCore['play'],
    pause: createCommonMethod('pause') as Components.TaroVideoCore['pause'],
    stop: createCommonMethod('stop') as Components.TaroVideoCore['stop'],
    seek: createCommonMethod('seek') as Components.TaroVideoCore['seek'],
    requestFullScreen: createCommonMethod('requestFullScreen') as Components.TaroVideoCore['requestFullScreen'],
    exitFullScreen: createCommonMethod('exitFullScreen') as Components.TaroVideoCore['exitFullScreen']
  },
  render: createCommonRender('taro-video-core', ['play', 'pause', 'ended', 'timeupdate', 'error', 'fullscreenchange', 'progress', 'loadedmetadata'], defineTaroVideoCore),
});


export const VideoDanmu = /*@__PURE__*/ Vue.extend({
  props: {
    enable: {} as PropOptions<JSX.TaroVideoDanmu['enable']>
  },
  methods: {
    sendDanmu: createCommonMethod('sendDanmu') as Components.TaroVideoDanmu['sendDanmu'],
    tick: createCommonMethod('tick') as Components.TaroVideoDanmu['tick']
  },
  render: createCommonRender('taro-video-danmu', [], defineTaroVideoDanmu),
});


export const View = /*@__PURE__*/ Vue.extend({
  props: {
    animation: {} as PropOptions<JSX.TaroViewCore['animation']>,
    hoverClass: {} as PropOptions<JSX.TaroViewCore['hoverClass']>,
    hoverStartTime: {} as PropOptions<JSX.TaroViewCore['hoverStartTime']>,
    hoverStayTime: {} as PropOptions<JSX.TaroViewCore['hoverStayTime']>
  },
  render: createCommonRender('taro-view-core', ['longpress'], defineTaroViewCore),
});


export const VoipRoom = /*@__PURE__*/ Vue.extend({
  render: createCommonRender('taro-voip-room-core', [], defineTaroVoipRoomCore),
});


export const WebView = /*@__PURE__*/ Vue.extend({
  props: {
    src: {} as PropOptions<JSX.TaroWebViewCore['src']>
  },
  render: createCommonRender('taro-web-view-core', ['load', 'error'], defineTaroWebViewCore),
});

